import React from 'react';
import { AlertTriangle } from 'lucide-react';
import { Button } from '@/components/ui/button';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null, errorInfo: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    this.setState({ error, errorInfo });
    
    // Log error to backend
    this.logError(error, errorInfo);
  }

  async logError(error, errorInfo) {
    try {
      const user = JSON.parse(localStorage.getItem('user') || '{}');
      
      await fetch(`${API}/error-logs`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          error_type: 'frontend',
          message: error.toString(),
          stack_trace: errorInfo?.componentStack || error.stack,
          user_id: user.user_id || null,
          user_email: user.email || null,
          url: window.location.href,
          browser: navigator.userAgent
        })
      });
    } catch (err) {
      console.error('Failed to log error:', err);
    }
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="min-h-screen flex items-center justify-center bg-slate-50 p-6">
          <div className="max-w-2xl w-full bg-white rounded-2xl border-2 border-red-200 p-8 text-center">
            <AlertTriangle className="w-16 h-16 mx-auto mb-4 text-red-500" />
            <h1 className="text-2xl font-bold text-slate-900 mb-2">Oops! Something went wrong</h1>
            <p className="text-slate-600 mb-6">
              An error occurred in the application. This has been automatically reported to our team.
            </p>
            <div className="bg-red-50 border border-red-200 rounded-lg p-4 mb-6 text-left">
              <p className="text-sm font-mono text-red-700">{this.state.error?.toString()}</p>
            </div>
            <div className="flex gap-3 justify-center">
              <Button
                onClick={() => window.location.href = '/dashboard'}
                className="bg-violet-600 hover:bg-violet-700 text-white"
              >
                Go to Dashboard
              </Button>
              <Button
                onClick={() => window.location.reload()}
                variant="outline"
              >
                Reload Page
              </Button>
            </div>
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
